import { render, staticRenderFns } from "./LobbySingle.vue?vue&type=template&id=0870f3a0&scoped=true&"
import script from "./LobbySingle.vue?vue&type=script&lang=js&"
export * from "./LobbySingle.vue?vue&type=script&lang=js&"
import style0 from "./LobbySingle.vue?vue&type=style&index=0&id=0870f3a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870f3a0",
  null
  
)

component.options.__file = "LobbySingle.vue"
export default component.exports